import { useMemo } from 'react'
import { useCurrentFrame, useVideoConfig } from 'remotion'
import { useFadeOpacity } from '../fades'
import type { SolidItem } from '../types'

export function SolidLayer({ item }: { item: SolidItem }) {
  const frame = useCurrentFrame()
  const { fps, durationInFrames } = useVideoConfig()

  const opacity = useFadeOpacity({
    frame,
    fps,
    durationInFrames,
    fadeInDurationInSeconds: item.fadeInDurationInSeconds,
    fadeOutDurationInSeconds: item.fadeOutDurationInSeconds,
    opacity: item.opacity,
  })

  const style: React.CSSProperties = useMemo(
    () => ({
      backgroundColor: item.color,
      position: 'absolute',
      left: item.left,
      top: item.top,
      width: item.width,
      height: item.height,
      opacity,
      borderRadius: item.borderRadius,
      transform: `rotate(${item.rotation}deg)`,
      // The stroke sits inside the box (#546), so a frame keeps its size.
      ...(item.stroke
        ? {
            boxSizing: 'border-box' as const,
            border: `${item.stroke.width}px solid ${item.stroke.color}`,
          }
        : {}),
    }),
    [
      item.color,
      item.height,
      item.left,
      item.top,
      item.width,
      opacity,
      item.borderRadius,
      item.rotation,
      item.stroke,
    ],
  )

  return <div style={style} />
}
